/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type InfoCircleFill = {
  className?: string
  fillClassName?: string
}

  const APP_VENDOR =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR
/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/
const InfoCircle = ({
  fillClassName = APP_VENDOR === "snai"
    ? "fill-[#1160D7]"
    : "fill-[#67AAF9]",
  className = "w-6 h-6",
}: InfoCircleFill) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="a"
      width={22}
      height={22}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path
        fill="#2E5AAC"
        fillRule="evenodd"
        d="M19.425 4.575A10.432 10.432 0 0 0 12 1.5a10.432 10.432 0 0 0-7.425 3.075A10.436 10.436 0 0 0 1.5 12c0 2.805 1.093 5.441 3.075 7.425A10.432 10.432 0 0 0 12 22.5c2.805 0 5.442-1.092 7.425-3.075A10.436 10.436 0 0 0 22.5 12c0-2.805-1.093-5.441-3.075-7.425ZM13.312 17.25a1.312 1.312 0 1 1-2.624 0v-6.563a1.312 1.312 0 1 1 2.624 0v6.563Zm-2.624-10.5a1.312 1.312 0 1 0 2.624 0 1.312 1.312 0 0 0-2.624 0Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#a)">
      <path className={fillClassName} d="M0 0h24v24H0z" />
    </g>
  </svg>
)
export { InfoCircle }
